<template>
    <el-dialog title="用户信息维护" :visible="visible" :show="show" width="40%"  :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基础信息" name="1">
                <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
                    <el-form-item label="头像" class="input" prop="headPicture">
                        <el-upload
                                ref="upload"
                                :action="fileUploadUrl"
                                list-type="picture-card"
                                :on-exceed="handleExceed"
                                :on-success="handleUploadSuccess"
                                style="float:left;margin-left: 35%;"
                        >
                            <i class="el-icon-plus"></i>
<!--                            <div slot="tip" class="el-upload__tip" style="color:#838fa1;">{{tip}}</div>-->
                        </el-upload>
                        <img v-if="ruleForm.headPicture" :src="url+'upload/'+ruleForm.headPicture" style="width:150px;height:150px"/>
                    </el-form-item>
                    <el-form-item label="姓名" class="input" prop="fullName">
                        <el-input v-model="ruleForm.fullName" autocomplete="off" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="账号" class="input" prop="account">
                        <el-input v-model="ruleForm.account" autocomplete="off" placeholder="请输入账号"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" class="input" prop="password" v-if="this.rowData.id==undefined">
                        <el-input v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码" type="password"></el-input>
                    </el-form-item>
                    <!--<el-form-item label="性别" class="input" prop="sex" >
                        &lt;!&ndash;<el-select v-model="ruleForm.sex" style="width:85%;margin-left:8%">
                            <el-option :label="'男'" :value="'1'"></el-option>
                            <el-option :label="'女'" :value="'2'"></el-option>
                        </el-select>&ndash;&gt;
                        <el-radio v-model="ruleForm.sex" label="1">男</el-radio>
                        <el-radio v-model="ruleForm.sex" label="2">女</el-radio>
                    </el-form-item>-->
                    <el-form-item label="是否锁定" class="input" prop="islock" >
                        <el-radio v-model="ruleForm.islock" label="1">正常</el-radio>
                        <el-radio v-model="ruleForm.islock" label="0">锁定</el-radio>
                    </el-form-item>
                    <!--<el-form-item label="邮箱" class="input" prop="email">
                        <el-input v-model="ruleForm.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" class="input" prop="phone">
                        <el-input v-model="ruleForm.phone" autocomplete="off" placeholder="请输入电话"></el-input>
                    </el-form-item>-->
                    <el-form-item label="手机" class="input" prop="mobile">
                        <el-input v-model="ruleForm.mobile" autocomplete="off" placeholder="请输入手机"></el-input>
                    </el-form-item>
                    <el-form-item label="有效期" class="input" prop="vipExpireDate" v-show="role=='管理员'">
                        <el-date-picker v-model="ruleForm.vipExpireDate" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="部门选择" name="2">
                <el-input v-model="ruleForm.orgName" ></el-input>
                <el-tree
                        class="filter-tree"
                        :data="companyTree"
                        :props="defaultProps"
                        default-expand-all
                        @node-click="handleNodeClick"
                        ref="tree">
                </el-tree>
            </el-tab-pane>
            <el-tab-pane label="角色授权" name="3">
                <el-transfer v-model="value" :data="data" :titles="['角色列表','已选角色列表']"
                             :button-texts="[ '取消','添加']"
                             :format="{
                                noChecked: '${total}',
                                hasChecked: '${checked}/${total}'
                              }"
                ></el-transfer>
            </el-tab-pane>
        </el-tabs>
        <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
            <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
            <el-button class="btn close" @click="close()">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
            companyAddUserFlag:{
                type:Boolean,
                default:false,
            }
        },
        watch:{
            show(){
                window.vm = this;
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.getRoleList();
                    this.initCompanyList();
                    this.role = this.$storage.get("role");
                }
                /*if (this.rowData.id==undefined){
                    this.ruleForm.sex = '1';
                    this.ruleForm.islock = '1';
                }*/
            },
            rowData(){
                if (this.rowData.id!=undefined){
                    this.rowData.islock = this.rowData.islock +'';
                    this.ruleForm = this.rowData;
                    this.ruleForm.orgName = this.rowData.departmentName;
                    this.ruleForm.vipExpireDate = new Date(this.rowData.vipExpireDate);
                    this.getSelectRoleList(this.rowData.id);
                }
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
            "value"(){
                //                console.log(this.value);
                if (this.value.length>1){
                    let roleStr = '';
                    this.data.map(item=>{
                        roleStr += item.label +",";
                    });
                    if (roleStr.indexOf("城市代理")!=-1 && roleStr.indexOf("站点代理")!=-1){
                        this.$message.error("两个代理角色不可同时设定！");
                        this.value = [];
                    }
                }
            }
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                fileUploadUrl:base.get().fileUploadUrl,
                visible:false,
                role:'',
                ruleForm:{
                    fullName:'',
                    account:'',
                    password:'',
                    sex:'1',
                    islock:'1',
                    email:'',
                    phone:'',
                    mobile:'',
                    headPicture:'',
                    companyId:'',
                    companyCode:'',
                    orgId:'',
                    orgCode:'',
                    orgName:'',
                    vipExpireDate:null,
                },
                rules:{
                    fullName:[{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    account:[{ required: true, message: '请输入账号', trigger: 'blur' }],
                    password:[{ required: true, message: '请输入密码', trigger: 'blur' }],
                    sex:[{ required: true, message: '请选择性别', trigger: 'blur' }],
                    islock:[{ required: true, message: '请选择是否锁定', trigger: 'blur' }],
                    /*email:[{ required: true, message: '请输入邮箱', trigger: 'blur' }],
                    phone:[{ required: true, message: '请输入电话', trigger: 'blur' }],*/
                    mobile:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                    ],
                },
                activeName:'1',
                value: [],
                data: [],
                defaultProps: {
                    children: 'companyList',
                    label: 'name'
                },
                companyTree:[],
                zdSiteShow:false,
            }
        },
        methods:{
            handleClick(tab, event) {
                console.log(tab, event);
            },
            close(){
                this.updateBtn = true;
                this.ruleForm = {
                    fullName:'',
                    account:'',
                    password:'',
                    sex:'1',
                    islock:'1',
                    email:'',
                    phone:'',
                    mobile:'',
                    headPicture:'',
                    companyId:'',
                    companyCode:'',
                    orgId:'',
                    orgCode:'',
                    orgName:'',
                    vipExpireDate:null,
                };
                this.data = [];
                this.value = [];
                this.ruleForm.orgId = null;
                this.ruleForm.orgName = null;
                this.ruleForm.companyId = null;
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (this.value.length<=0){
                        this.$message.error("请设置用户角色");
                        this.activeName = '3';
                        return;
                    }
                    if((this.ruleForm.orgName=='' || this.ruleForm.orgName==null) && this.companyAddUserFlag){
                        this.$message.error("请设置部门信息");
                        this.activeName = '2';
                        return;
                    }
                    if (valid) {
                        let userRoleId = this.value.join(",");
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`users/`+"save?selectRoleIds="+userRoleId
                            :this.url+`users/`+"update?selectRoleIds="+userRoleId,
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }else{
                        this.activeName = '1';
                    }
                });
            },

            getRoleList(){
                let params = {'companyAddUserFlag':this.companyAddUserFlag};
                this.$http({
                    url: "sysRole/list",
                    method: "get",
                    params
                }).then(({data}) => {
                    if(data && data.code === 0){
                        let list = data.data;
                        list.map(item=>{
                            let obj = {label:item.roleName,key:item.roleId};
                            this.data.push(obj);
                        })
                    }
                });
            },
            getSelectRoleList(userId){
                this.$http({
                    url: "users/getSelectRoleListByUserId/"+userId,
                    method: "get",
                }).then(({data}) => {
                    if(data && data.code === 0){
                        let list = data.selectRoleList;
                        list.map(obj=>{
                            this.value.push(obj.roleId);
                        })
                    }
                });
            },
            beforeAvatarUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 JPG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            // 上传文件成功后执行
            handleUploadSuccess(res, file, fileList) {
                this.ruleForm.headPicture = file.response.file;
            },
            handleExceed(files, fileList) {
                this.$message.warning(`最多上传${this.limit}张图片`);
            },
            initCompanyList(){
                this.$http({
                    url: "company/getTreeCompanyList",
                    method: "get",
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.companyTree = [];
                        this.companyTree.push(data.rootOrg);
                    }
                });
            },
            handleNodeClick(data) {
                this.ruleForm.orgId = data.id;
                this.ruleForm.orgName = data.name;
                this.ruleForm.companyId = data.path.substring(0,data.path.indexOf("."));
                this.$forceUpdate();
            }


        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>